import React from 'react'
import Image from '../../../../../containers/Detail/Image/Image'
import RequestList from '../RequestList/RequestList'
import {fetchServiceRequestsForEquipment} from '../../../../../api/servicerequest'
import {fetchEquipment} from '../../../../../utils/equipment'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'
import styled from 'styled-components'
import {useViewFetch} from '../../../../../utils/fetch'

const fetchEquipmentQrData = async ({eqId}) => {
  const [equipment, requests] = await Promise.all(
    [fetchEquipment, fetchServiceRequestsForEquipment].map(fn => fn({eqId}))
  )

  return {
    equipment,
    requests
  }
}

const Equipment = ({eqId, createRequest}) => {
  const localeState = useLocaleState()

  const {data} = useViewFetch({
    api: fetchEquipmentQrData,
    parameters: {eqId},
    initialState: {equipment: {}, requests: []},
    onChangeOf: [eqId]
  })

  const {equipment, requests} = data

  const onClick = () => createRequest(equipment)

  const {
    name,
    use1,
    mfr,
    rmId,
    description,
    flId,
    comments,
    imageUrl,
    modelno
  } = equipment

  const modelNo = modelno ? `- ${modelno}` : ''

  return (
    <Container>
      <ImageContainer>
        <StyledImage>
          <Image url={imageUrl} imageType="equipment" placeholder />
        </StyledImage>
      </ImageContainer>

      <EquipmentContainer>
        <EquipmentDetail>
          <EquipmentTitle>
            {use1} {eqId}
          </EquipmentTitle>
          <EquipmentText>
            <div>
              {mfr} {modelNo}
            </div>
            <EquipmentLocation>
              <div>
                {rmId} - {description}
              </div>
              <div>
                {name} <MiddleDot>&#183;</MiddleDot> Floor {flId}
              </div>
              <div>{comments}</div>
            </EquipmentLocation>
          </EquipmentText>
        </EquipmentDetail>
      </EquipmentContainer>

      <ButtonContainer>
        <StyledButton onClick={onClick}>
          {_L({key: 'CREATE A REQUEST', localeState})}
        </StyledButton>

        <RecentRequestContainer>
          <div>{_L({key: 'RECENT REQUESTS', localeState})}</div>
        </RecentRequestContainer>
      </ButtonContainer>
      <RequestListContainer>
        <RequestList requests={requests} />
      </RequestListContainer>
    </Container>
  )
}

export default Equipment

const Container = styled.div`
  width: 600px;
  height: 600px;
  box-sizing: border-box;
  background-color: white;
  border-radius: 8px;
  display: grid;
  grid-template-rows: 200px auto auto 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: 'image' 'equipment' 'button' 'requests';

  @media (max-width: 630px) {
    width: 100vw;
    height: calc(100vh - 80px);
    border-radius: 0;
    grid-template-rows: 180px auto 120px 1fr;
  }

  @media (max-width: 420px) {
    height: calc(100vh - 110px);
    overflow-y: scroll;
  }
`

const ImageContainer = styled.div`
  grid-area: image;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  justify-content: center;
`
const StyledImage = styled.div`
  width: 180px;
  height: 180px;
`

const EquipmentContainer = styled.div`
  height: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  grid-area: equipment;
`

const EquipmentDetail = styled.div`
  padding: 8px 20px 8px 20px;
  box-sizing: border-box;
`

const EquipmentTitle = styled.div`
  font-size: 20px;
  font-weight: 700;

  @media (max-width: 630px) {
    padding-top: 10px;
  }

  @media (max-width: 420px) {
    font-size: 18px;
  }
`

const EquipmentText = styled.div`
  font-size: 16px;
  font-weight: normal;
  color: #000000;
`

const EquipmentLocation = styled.div`
  margin-top: 10px;
  color: #a4a9b7;

  @media (max-width: 420px) {
    font-size: 14px;
  }
`

const MiddleDot = styled.span`
  padding: 0 6px 0 6px;
`

const RequestListContainer = styled.div`
  height: 100%;
  min-height: 200px;
  grid-area: requests;
  box-sizing: border-box;
  padding: 4px 10px 24px 16px;

  @media (max-width: 420px) {
    padding: 0 16px 14px 16px;
  }
`

const ButtonContainer = styled.div`
  height: 100%;
  grid-area: button;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const RecentRequestContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  height: 46px;
  background: #f3f5fb;
  color: #a4a9b7;
  font-weight: 600;
  margin-top: 5px;
  padding-left: 20px;
  box-sizing: border-box;
`

const StyledButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  background-color: #3395fe;
  border: 2px solid #3395fe;
  color: #ffffff;
  height: 46px;
  border-radius: 6px;
  outline: none;
  width: 90%;
`
